/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./model-manage.vue?vue&type=template&id=4b18f965&scoped=true&"
import script from "./model-manage.vue?vue&type=script&lang=ts&"
export * from "./model-manage.vue?vue&type=script&lang=ts&"
import style0 from "./model-manage.vue?vue&type=style&index=0&id=4b18f965&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18f965",
  null
  
)

export default component.exports